import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCardAssignedList,
  getCardPendingList,
  updateConfig,
} from "../../../store/slices/Staff/recheckStaffSlice";
import getFilterCount from "../../../utils/getFilterCount";

const useRecheckStaffWindow = () => {
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [pendingPage, setPendingPage] = useState(1);
  const [assignedPage, setAssignedPage] = useState(1);
  const staffState = useSelector((state) => state.recheckStaff);
  const slug = sessionStorage?.getItem("slug");


  useEffect(() => {

      dispatch(
          updateConfig((state) => {
            state.cardData.Pending = [];
            state.cardData.Assigned = [];
            state.search = "";
          })
        );
    dispatch(
      getCardPendingList({
        page: 1,
        per_page: 10,
        date: staffState.date,
        item_type: staffState.item_type,
        shop: staffState.shop,
        status: staffState.status,
        process_slug: slug,
      })
    );
    dispatch(
      getCardAssignedList({
        page: 1,
        per_page: 10,
        date: staffState.date,
        item_type: staffState.item_type,
        shop: staffState.shop,
        status: staffState.status,
        process_slug: slug,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    staffState.date,
    staffState.item_type,
    staffState.shop,
    staffState.status,
    slug,
  ]);

  const handleFilter = () => {
    dispatch(
      updateConfig((state) => {
        state.showFilter = !state.showFilter;
      })
    );
  };


    useEffect(() => {
      if (pendingPage >= 1) {
        if (staffState.cardData.Pending?.length <= staffState.PendingTotal) {
          dispatch(
            getCardPendingList({
              page: pendingPage,
              per_page: 10,
              process_slug: slug,
              search: staffState.search,
            })
          );
        } else if (staffState.cardData.Pending?.length > staffState.PendingTotal)
          setIsLoading(false);
      }
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingPage]);


      useEffect(() => {
        if (assignedPage >= 1) {
          if (staffState.cardData.Assigned?.length <= staffState.AssignedTotal) {
            dispatch(
              getCardAssignedList({
                page: assignedPage,
                per_page: 10,
                process_slug: slug,
                search: staffState.search,
              })
            );
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [assignedPage]);


    const handleLoadMore = (mouseHover) => {
      if (
        mouseHover === "Pending" &&
        staffState?.cardData?.Pending?.length <= staffState?.PendingTotal
      ) {
        setPendingPage(pendingPage + 1);
        dispatch(
          updateConfig((state) => {
            state.currentPage = pendingPage + 1;
          })
        );
      }
      if (
        mouseHover === "Assigned" &&
        staffState?.cardData?.Assigned?.length <= staffState?.AssignedTotal
      ) {
        setAssignedPage(assignedPage + 1);
        dispatch(
          updateConfig((state) => {
            state.currentPage = assignedPage + 1;
          })
        );
      }
    };

    useEffect(() => {
      if (isLoading) {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [staffState?.cardAssignedStatus, staffState?.cardPendingStatus]);
  

  const handleCardClick = (item, key) => {
    setActiveCard({ id: item?._id, key: key });
    dispatch(
      updateConfig((state) => {
        state.gliData.name = item?.gli_number;
        state.gliData.id = item?._id;
        state.gliData.shop = item?.shop;
      })
    );
    if (key === "Pending") {
      // dispatch(getTableData(item?._id));
      dispatch(
        updateConfig((state) => {
          state.showAssignedTable = false;
          state.showTable = true;
        })
      );
    } else if (key === "Assigned") {
      dispatch(
        updateConfig((state) => {
          // state.certificateData = response?.data?.data;
          state.showTable = false;
          state.showAssignedTable = true;
        })
      );
    }
  };
  const handleStartClick = () => {
    switch (sessionStorage?.getItem("slug")) {
      case "cvd_rft":
        navigate("cvd-work-recheck");
        break;
      case "qc":
        navigate("qc-work-recheck");
        break;
      case "metal_qc":
        navigate("metal-qc-work-recheck");
        break;
      case "og_qc":
        navigate("old-gold-qc-work-recheck");
        break;
      case "final_qc":
        navigate("final-qc-work-recheck");
        break;
      case "drumball":
        navigate("drum-ball-work-recheck");
        break;
      case "photo_section":
        navigate("photo-upload-work-recheck");
        break;
      case "engraving":
        navigate("engraving-work-recheck");
        break;
      case "billing":
        navigate("billing");
        break;
      case "packing":
        navigate("packing-work-recheck");
        break;
      case "printing":
        navigate("printing-work-recheck");
        break;
      case "delivery":
        navigate("delivery-work-recheck");
        break;
      default:
        navigate("/");
    }
  };

  const filterCount = useMemo(() => {
    return getFilterCount({
      from_date: staffState.from_date,
      to_date: staffState.to_date,
      item_type: staffState.item_type,
      shop: staffState.shop,
      status: staffState.status,
    });
  }, [staffState.from_date, staffState.to_date, staffState.item_type, staffState.shop, staffState.status]);

  const handleSearchInput = (e) => {
    const searchValue = e?.target?.value;
    dispatch(updateConfig((state) => (state.search = searchValue)));
  };

  const handleSearch = () => {
    const searchValue = staffState?.search;

    dispatch(
      updateConfig((state) => {
        state.cardData.Pending = [];
        state.cardData.Assigned = [];
      })
    );
    dispatch(
      getCardPendingList({
        search: searchValue,
        page: 1,
        process_slug: slug,
      })
    );
    dispatch(
      getCardAssignedList({
        search: searchValue,
        page: 1,
        process_slug: slug,
      })
    );
  };

  return {
    activeCard,
    staffState,
    isLoading,
    filterCount,
    setIsLoading,
    handleCardClick,
    handleFilter,
    handleSearchInput,
    handleStartClick,
    handleSearch,
    handleLoadMore,
    totalLength: {
      Pending: staffState?.PendingTotal,
      Assigned: staffState?.AssignedTotal,
    },
    apiStatus: {
      Pending: staffState.cardPendingStatus,
      Assigned: staffState.cardAssignedStatus,
    },
  };
};

export default useRecheckStaffWindow;
